export default __webpack_public_path__ + "static/media/reporting.51fe8575.svg";